<app-tabs>
  <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">Emergency</li>
</app-tabs>

<div [hidden]="tabs_service.is_active()">
  <ng-container *ngIf="emergency_service.isFilterLoaded()">
    <app-emergency-filters></app-emergency-filters>
    <app-emergency-listing></app-emergency-listing>
  </ng-container>
</div>